import React from 'react'
import Slider from './Slider/Slider';


const Hero = () => {

    return (
        <Slider />
    )
}

export default Hero;